var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecryptDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#34DAE2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "multimedia-option",
    transform: "translate(88.154 1.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    transform: "translate(20.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    className: "st0",
    d: "M-93.62,8.02c-0.09-0.21-0.3-0.34-0.53-0.34h-2.31V0.17c0-0.32-0.26-0.58-0.58-0.58 c0,0,0,0,0,0h-2.31c-0.32,0-0.58,0.26-0.58,0.58c0,0,0,0,0,0v7.52h-2.31c-0.32,0-0.58,0.26-0.58,0.58c0,0.14,0.05,0.28,0.14,0.38 l4.05,4.62c0.21,0.24,0.57,0.27,0.81,0.06c0.02-0.02,0.04-0.04,0.06-0.06l4.05-4.62C-93.57,8.47-93.53,8.23-93.62,8.02z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    transform: "translate(16 12.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    className: "st0",
    d: "M-87.79-0.41v3.47h-12.72v-3.47h-2.31v4.62c0,0.64,0.52,1.16,1.16,1.16c0,0,0,0,0,0h15.03 c0.64,0,1.16-0.52,1.16-1.15c0,0,0,0,0,0v-4.62H-87.79z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecryptDownload);
export default __webpack_public_path__ + "static/media/recrypt_download.441bc333.svg";
export { ForwardRef as ReactComponent };